import { createSelector } from "@ngrx/store";
import { SystemNotification } from "src/app/components/core/notification-snackbar/models/system-notification.class";
import { AppState } from "../states/app.state";
import { SystemState } from "../states/system.state";

const systemState = (state: AppState): SystemState => state.system;
export const selectLoading = createSelector(systemState, (state: SystemState): boolean => state.loading);
export const selectNotifications = createSelector(systemState, (state: SystemState): SystemNotification | undefined => state.notification);